import { useQuery } from "@tanstack/react-query";
import { useProductionService } from "../services/production";

export function useProductionPersonDetail(employeeId: string | undefined, days: number = 30) {
  const service = useProductionService();
  return useQuery({
    queryKey: ["production-person-detail", employeeId, days],
    queryFn: () => {
      if (!employeeId) throw new Error("employeeId required");
      return service.getPersonDetail(employeeId, days);
    },
    enabled: !!employeeId,
    staleTime: 5 * 60_000,
    refetchInterval: 10 * 60_000,
  });
}
